import { IconProps } from '@/components/Icons/types/IconInterface';
import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from '@/components/Icons/iconVariant';

interface CopyIconProps extends IconProps {
  onClick?: () => void;
}

const CopyIcon: React.FC<CopyIconProps> = ({ variant, size, className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={cn(iconVariant({ variant, size, className }))}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.125 7.5625V5.5C15.125 4.36091 14.2016 3.4375 13.0625 3.4375H5.5C4.36091 3.4375 3.4375 4.36091 3.4375 5.5V13.0625C3.4375 14.2016 4.36091 15.125 5.5 15.125H7.5625M15.125 7.5625H16.5C17.6391 7.5625 18.5625 8.48591 18.5625 9.625V16.5C18.5625 17.6391 17.6391 18.5625 16.5 18.5625H9.625C8.48591 18.5625 7.5625 17.6391 7.5625 16.5V15.125M15.125 7.5625H9.625C8.48591 7.5625 7.5625 8.48591 7.5625 9.625V15.125"
        stroke="#010F55"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CopyIcon;
